import { render, staticRenderFns } from "./BaseImagePreview.vue?vue&type=template&id=c146db80&scoped=true"
import script from "./BaseImagePreview.vue?vue&type=script&lang=js"
export * from "./BaseImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146db80",
  null
  
)

export default component.exports